export default __webpack_public_path__ + "static/media/card-discover.f9ddeb8d.svg";